// =============================================================================
// Server-safe constants of the intro preloader (no "use client": the layout
// inlines the script in the <head>, which must stay free of client modules)
// =============================================================================

/** sessionStorage key set once the preloader has played in this session */
export const PRELOADER_STORAGE_KEY = "preloader-done";

/**
 * Inline script run before the first paint: skips the preloader for the rest
 * of the session and for visitors who prefer reduced motion.
 */
export const PRELOADER_SCRIPT = `(function(){try{var d=document.documentElement;if(sessionStorage.getItem("${PRELOADER_STORAGE_KEY}")||matchMedia("(prefers-reduced-motion: reduce)").matches){d.dataset.preloader="skip"}}catch(e){document.documentElement.dataset.preloader="skip"}})();`;

// =============================================================================
